<template>
    <div class="u-form u-mt1">
        <h3 class="u-mt2">Edit profile</h3>
        <div v-if="user.is_creator">
            <div v-if="!editingAvatar">
                <ion-avatar class="big-avatar">
                    <img :src="avatar">
                </ion-avatar>
                <ion-button shape="round" v-on:click="editAvatar()">Choose another picture</ion-button>
            </div>
            <div v-else>
                <image-upload :set-media="setAvatar" :data-url="true"/>
            </div>
        </div>

        <ion-label>Your Name</ion-label>
        <ion-input placeholder="Title" type="text" shape="round" expand="full" :value="name" v-on:ionInput="setName($event)" style='background:var(--ion-color-light); border-radius: 20px; margin-bottom: 12px; text-align: left; --padding-start: 20px'></ion-input>

        <ion-label>Your Email</ion-label>
        <ion-input placeholder="Email Address" type="email" shape="round" expand="full" :value="email" v-on:ionInput="setEmail($event)" style='background:var(--ion-color-light); border-radius: 20px; margin-bottom: 12px; text-align: left; --padding-start: 20px'></ion-input>

        <div v-if="user.is_creator">
            <ion-label>Your Profile</ion-label>
            <ion-textarea placeholder="Your Message" :value="profile" rows="12" type="text" shape="round" expand="full" v-on:ionInput="setProfile($event)" style='background:var(--ion-color-light); border-radius: 20px; margin-bottom: 12px; text-align: left; --padding-start: 20px'></ion-textarea>
        </div>
        <ion-button shape="round" expand="full" v-on:click="saveProfile()">Save</ion-button>
        <ion-button shape="round" expand="full" v-on:click="closeEdit()" color="medium" style="color : var(--ion-color-dark);">Cancel</ion-button>
    </div>
</template>

<script>
import ImageUpload from '@/components/ImageUpload.vue'
import {alerts} from '@/mixins/alerts';
export default {
    props : {
        user : Object,
        closeEdit : Function
    },
    mixins : [alerts],
    data : function () {
        let name       = this.user.name,
            email      = this.user.email,
            profile    = this.user.profile,
            avatar     = this.user.avatar,
            editingAvatar = false;
        if (!avatar) {
            editingAvatar = true;
        }
        return {
            name : name,
            email : email,
            profile : profile,
            avatar : avatar,
            editingAvatar : editingAvatar,
            editedAvatar : false
        }
    },
    components : {
        ImageUpload
    },
    methods : {
        editAvatar : function () {
            this.editingAvatar = true;
            this.editedAvatar = false;
        },
        setAvatar : function (avatar) {
            this.avatar = avatar;
            console.log('avatar', this.avatar);
            // this.editingAvatar = false;
            this.editedAvatar = true;
        },
        setProfile : function (event) {
            this.profile = event.target.value;
        },
        setName : function (event) {
            this.name = event.target.value;
        },
        setEmail : function (event) {
            this.email = event.target.value;
        },
        saveProfile : function () {
            let self = this,
                params = {
                    name    : this.name,
                    profile : this.profile,
                    email   : this.email
                };
            console.log('avatar', this.editedAvatar, this.avatar);
            if (this.editedAvatar) {
                params.avatar = this.avatar;
            }
            this.axios.put(this.api + 'users/profile/' + this.user.id, params)
                .then(response => {
                    self.$root.setUser(response.data);
                    self.showSuccess('You have edited your profile', function () {
                        self.closeEdit();
                    });
                })
                .catch(error => {
                    // console.log('Error updating profile', error);
                    self.showError('We could not update your profile.  Please check the information you provided and try again');
                });
        }
    }
}
</script>
